import React from "react"; import { useKami } from "../context/KamiContext"; import commandList from "../data/commandList";

/**

CommandGrid.js

Renders a responsive grid of system command buttons.

Each button triggers an action and records it in Kami memory. */


export default function CommandGrid() { const { recordCommand } = useKami();

const handleCommandClick = (command) => { if (typeof command.action === "function") { command.action(); } else {
console.warn(`No action defined for command: ${command.label}`);

 } recordCommand(command.label); };

return ( <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", marginBottom: "30px", }} > {commandList.map((command, index) => ( <button key={index} onClick={() => handleCommandClick(command)} style={{ backgroundColor: "#0369a1", color: "white", padding: "10px 20px", borderRadius: "12px", border: "none", cursor: "pointer", boxShadow: "0 0 10px #00ffff", fontSize: "0.9rem", }} > {command.label} </button> ))} </div> ); }

